import { BreakpointObserver } from '@angular/cdk/layout';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, map } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class RedirectToPanelGuard implements CanActivate {
	constructor(
		private router: Router,
		private breakpointObserver: BreakpointObserver
	) {}

	canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
		const panelPath = route.routeConfig?.path ?? '';

		return this.breakpointObserver.observe(['(min-width: 768px)']).pipe(
			map(result => {
				if (result.matches) {
					return this.router.createUrlTree([
						'/',
						{
							outlets: {
								panel: [panelPath]
							}
						}
					]);
				}

				return true;
			})
		);
	}
}
